export interface Company {
  id: string;
  name: string;
  creditCode: string;
  address: string;
  website: string;
  type: '实体企业' | '认证机构' | '第三方咨询机构';
  responsiblePerson: string;
  assignedTo: string;
  assignedToName: string;
  businessTags: string[];
  sourceTags: string[];
  contacts: Contact[];
  businessDemands: BusinessDemand[];
  createdAt: string;
  updatedAt: string;
}

export interface Contact {
  id: string;
  name: string;
  phone: string;
  position: string;
}

export interface BusinessDemand {
  id: string;
  description: string;
  source: string;
  sourceTag: string;
  date: string;
}

export const companyTypeOptions = ['全部', '实体企业', '认证机构', '第三方咨询机构'];

export const allBusinessTags = [
  '绿证', '碳交易', '碳排放核算', 'CCUS', '碳核查', '碳足迹',
  '碳中和认证', 'EPD', 'ISO 14064', 'ISO 14067', 'PAS 2050',
  'CBAM', '绿色供应链', '能效提升', '碳达峰方案', '碳管理咨询',
  'CCER开发', 'ESG报告', '碳金融', '碳资产管理', '碳中和',
  '光伏碳减排', '可再生能源', 'RE100', 'SBTi', '绿色产品认证',
];

export const allSourceTags = [
  '绿色工厂', '碳中和先锋', 'CNAS认可机构', '碳排放核查机构名单',
  '碳交易服务机构', '国家备案CCER审定机构', '能耗双控重点企业',
  '国家重点认证机构', '新能源领军企业', 'CDP授权服务商',
  '国家备案碳交易机构', '上海碳市场运营机构', '北京碳市场运营机构',
  '零碳工厂', '石化行业智库', '国家重点研究机构', '光伏龙头企业',
];